import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { OpenerConstraint } from 'src/app/api/api-campaigns.service.generated';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { FlexLayoutModule } from '@angular/flex-layout';

@Component({
  selector: 'app-opener-scheme-constraint',
  templateUrl: './opener-scheme-constraint.component.html',
  styleUrls: ['./opener-scheme-constraint.component.scss'],
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FlexLayoutModule,
    ReactiveFormsModule,
  ]
})
export class OpenerSchemeConstraintComponent implements OnInit {
  @Output() onFormChanged: EventEmitter<boolean> = new EventEmitter<boolean>(false);
  @Input() set constraint(value: any) {
    if (!value) return;
    this.setFormValue(value);
  }

  public form: FormGroup;

  constructor() {
    this.init();
  }

  ngOnInit() {
    this.form.valueChanges.subscribe(() => {
      if (!this.form.valid)
        this.onFormChanged.next(false);
      else this.onFormChanged.next(true);
    })
  }

  private init() {
    this.form = new FormGroup({
      userDailyPoints: new FormControl(null, Validators.min(1)),
      userTotalPoints: new FormControl(null, Validators.min(1)),
      openerDailyPoints: new FormControl(null, Validators.min(1)),
      openerTotalPoints: new FormControl(null, Validators.min(1))
    });
  }

  private setFormValue(model: any) {
    this.form.patchValue({
      userDailyPoints: model.userDailyPoints,
      userTotalPoints: model.userTotalPoints,
      openerDailyPoints: model.openerDailyPoints,
      openerTotalPoints: model.openerTotalPoints
    });
  }

  public getConstraint(): OpenerConstraint {
    return new OpenerConstraint({
      userDailyPoints: this.form.value.userDailyPoints,
      userTotalPoints: this.form.value.userTotalPoints,
      openerDailyPoints: this.form.value.openerDailyPoints,
      openerTotalPoints: this.form.value.openerTotalPoints
    });
  }
}
